module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"flop":"Penner","productPerformance":"Artikelperformance {siteId}","range":"Reichweite","top":"Renner","stock":"Bestand","salesDefaultUnit":"Verkauf GE"},"en":{"flop":"Flop","productPerformance":"Proudt performance {siteId}","range":"Range","top":"Top","stock":"Stock","salesDefaultUnit":"Sales default unit"}}')
  delete Component.options._Ctor
}
